"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _shared = require("./shared");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Flex = _styledComponents["default"].div.withConfig({
  shouldForwardProp: _shared.shouldForwardProp
}).withConfig({
  displayName: "flex__Flex",
  componentId: "sc-1v5lzn7-0"
})(["background-position:center right;display:flex;", ";"], _shared.defaultSystemProps);

Flex.displayName = "Primitives.Flex";
var _default = Flex;
exports["default"] = _default;